import { Sentence } from 'interfaces/db/sentence'
import { formatSeconds } from './format-seconds'

export const vttGenerator = (sentences: Sentence[], speakers = false) => {
  let vttOut = 'WEBVTT\n\n'
  sentences.forEach((v, i) => {
    vttOut += `${i + 1}\n${formatSeconds(v.start)} --> ${formatSeconds(
      v.end
    )}\n${speakers ? `<v ${v.speaker}>` : ``}${v.text}\n\n`
  })

  return vttOut
}
